import { getAuthApiUrl } from '@/config/config'
import { getWpcauthForExternalApi } from '@/api/services/auth.service'
import type { WireColor, WireColorStyle } from '@/api/types/color'
import { logger } from '@/utils/logger'

async function fetchColorEndpoint<T>(path: string): Promise<T> {
  const base = getAuthApiUrl().replace(/\/$/, '')
  const wpcauth = getWpcauthForExternalApi()

  if (!wpcauth) {
    throw new Error('Color API requires wpcauth session; please log in.')
  }

  const response = await fetch(`${base}${path}`, {
    method: 'GET',
    headers: { Accept: 'application/json', wpcauth },
  })

  if (!response.ok) {
    const text = await response.text().catch(() => '')

    throw new Error(
      `Color request failed [${path}]: ${response.status} ${response.statusText}${text ? ` — ${text}` : ''}`
    )
  }

  const data: unknown = await response.json()

  if (typeof data !== 'object' || data === null || !('result' in data) || !('payload' in data)) {
    throw new Error(`Color API at ${path} returned unexpected response shape`)
  }

  const typed = data as { result: unknown; payload: unknown }

  if (!typed.result) {
    logger.warn('Color API returned result: false', { path, data })
    throw new Error(`Color API at ${path} returned result: false`)
  }

  return typed.payload as T
}

async function getColors(): Promise<WireColor[]> {
  return fetchColorEndpoint<WireColor[]>('/core1/color')
}

async function getColorStyles(): Promise<WireColorStyle[]> {
  return fetchColorEndpoint<WireColorStyle[]>('/core1/colorStyle/all')
}

export const colorsService = { getColors, getColorStyles }
